module.exports = __webpack_public_path__ + "static/media/logo-sendero.eaf31289.svg";